import { Flex } from '@energiebespaarders/symbols';
import type { GetStaticProps } from 'next';
import Head from 'next/head';
import React from 'react';
import type { FormAddress } from '~/components/AddressFields';
import DrutenWijchenHero from '~/components/BuildingBlocks/DrutenWijchenHero';
import DrutenWijchenNav from '~/components/BuildingBlocks/DrutenWijchenNav';
import DrutenWijchenProcess from '~/components/BuildingBlocks/DrutenWijchenProcess';
import DrutenWijchenQuote from '~/components/BuildingBlocks/DrutenWijchenQuote';
import DrutenWijchenSubsidies from '~/components/BuildingBlocks/DrutenWijchenSubsidies';
import DrutenWijchenTruster from '~/components/BuildingBlocks/DrutenWijchenTruster';
import ErrorBoundary from '~/components/ErrorBoundary';
import DrutenWatermark from '/public/img/campaigns/buildingBlocks/Druten-watermark.svg';
import DrutenLogo from '/public/img/campaigns/buildingBlocks/Druten.svg';

interface DrutenWijchenLandingProps {
  addresses: FormAddress[];
}

const WijchenLanding: React.FC<DrutenWijchenLandingProps> = ({ addresses }) => {
  const props = {
    name: 'Druten',
    primaryColor: '#009ada',
    logo: DrutenLogo,
    watermark: DrutenWatermark,
  };
  return (
    <ErrorBoundary>
      <Head>
        <title>Wijkaanpak Isolatie Wijchen | Energiebespaarders</title>
        <meta
          name="description"
          content="Wijkaanpak isolatie in Wijchen. Energiebespaarders helpt je met isolatie en subsidie."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <Flex flexWrap="wrap">
        <DrutenWijchenNav {...props} />
        <DrutenWijchenHero addresses={addresses} {...props} />
        <DrutenWijchenTruster {...props} />
        <DrutenWijchenProcess {...props} />
        <DrutenWijchenSubsidies {...props} />
        <DrutenWijchenQuote {...props} />
      </Flex>
    </ErrorBoundary>
  );
};

export const getStaticProps: GetStaticProps<DrutenWijchenLandingProps> = async () => {
  const addresses = await fetch(
    'https://storage.googleapis.com/deb-documents/data/dw-addresses.json',
    { mode: 'no-cors' },
  ).then(res => res.json());
  return { props: { addresses }, revalidate: 3600 };
};

export default WijchenLanding;
